const CommonUtils = {
    /**
     * 图片加载函数
     * @param {*} event
     */
    successLoadImg (event) {
        let target = event.target || event.srcElement;
        let scale =
            target.parentElement.offsetWidth /
            target.parentElement.offsetHeight;
        let image = target;
        if (image.complete === true) {
            if (image.naturalWidth > image.naturalHeight * scale) {
                image.style.cssText = 'width: 100%;';
            } else {
                image.style.cssText = 'height: 100%;';
            }
        }
    },

    /**
     * 深拷贝
     * @param {*} obj
     */
    deepClone (obj) {
        let str;
        let newobj = obj.constructor === Array ? [] : {};
        if (typeof obj !== 'object') {
            return;
        } else if (window.JSON) {
            str = JSON.stringify(obj); // 系列化对象
            newobj = JSON.parse(str); // 还原
        }
        return newobj;
    },

    /**
     * 检查是否是空对象
     * @param {*} obj
     */
    checkNullObject (obj) {
        if (typeof obj === 'object') {
            if (JSON.stringify(obj) === '{}') {
                return false;
            } else {
                return true;
            }
        } else {
            return !!obj;
        }
    },

    /**
     * getUid - 生成一个n为的随机数
     *  @param {n} 生成位数
     * @return {id}      di
     */
    getUid (n = 16) {
        let chars = [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            'a',
            'b',
            'c',
            'd',
            'e',
            'f',
            'g',
            'h',
            'i',
            'j',
            'k',
            'l',
            'm',
            'n',
            'o',
            'p',
            'q',
            'r',
            's',
            't',
            'u',
            'v',
            'w',
            'x',
            'y',
            'z'
        ];
        let result = '';
        for (let i = 0; i < n; i++) {
            let id = Math.ceil(Math.random() * chars.length);
            result += chars[id];
        }
        return result;
    },

    /**
     * 数组去重（支持含对象数组）
     * @param {*} array 目标数组
     */
    unique (array) {
        var obj = {};
        return array.filter(function (item) {
            return obj.hasOwnProperty(typeof item + JSON.stringify(item))
                ? false
                : (obj[typeof item + JSON.stringify(item)] = true);
        });
    },

    /**
     * 去除前后空格
     * @param {String} x
     */
    trim (x) {
        if (typeof x === 'string') {
            if (String.trim) {
                return x.trim();
            } else {
                return x.replace(/^\s+|\s+$/gm, '');
            }
        }
        return x;
    },

    /**
     * 表单下载功能
     * @param {*} action
     * @param {*} params
     * @param {*} method
     * @param {*} target
     */
    downloadByForm ({ action, method = 'POST', params, target = '_self', enctype }) {
        let form = document.createElement('form');
        form.style.display = 'none';
        form.action = action;
        form.method = method;
        form.target = target;
        if (enctype) {
            form.enctype = enctype;
        }
        document.body.appendChild(form);
        for (let key in params) {
            if (typeof params[key] !== 'undefined') {
                let input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                if (typeof params[key] === 'object') {
                    input.value = JSON.stringify(params[key]);
                } else {
                    input.value = params[key];
                }
                form.appendChild(input);
            }
        }
        form.submit();
        form.remove();
    }
};
export default CommonUtils;
